import {announceFromElement} from '@github-ui/aria-live'
// eslint-disable-next-line no-restricted-imports
import {observe} from '@github/selector-observer'

observe('.js-starred-repos-search-results', function (el) {
  announceFromElement(el as HTMLElement)
})
